module.exports = __webpack_public_path__ + "static/img/2-3-1.c042c51b.jpg";